import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

/* Router Modules */

/** note: Submenu only appear when children.length>=1
*  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
**/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
  title: 'title'               the name show in submenu and breadcrumb (recommend set)
  icon: 'svg-name'             the icon show in the sidebar,
  noCache: true                if true ,the page will no be cached(default is false)
}
**/

import Home from '@/views/home/index'
import LocationList from '@/views/location/list'
import LocationDetails from '@/views/location/details'
import Reservation from '@/views/reservation/index'
import ReservationConfirmation from '@/views/reservation/confirmation'
import ReservationSuccess from '@/views/reservation/success'
import Dashboard from '@/views/dashboard/index'
import HotelPartner from '@/views/hotel_partner/index'

import Apps from '@/views/pages/apps'
import Privacy from '@/views/pages/privacy'
import Terms from '@/views/pages/terms'
import Contact from '@/views/pages/contact'
import CabanaappPrivacy from '@/views/pages/cabanaapp-privacy'
import CabanaappTerms from '@/views/pages/cabanaapp-terms'

import Login from '@/views/login/index'
import AuthRedirect from '@/views/login/authredirect'
import Redirect from '@/views/redirect/index'
import Page404 from '@/views/errorPage/404'
import Page401 from '@/views/errorPage/401'

export const constantRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: 'home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home,
        hidden: true
      },
      {
        path: '/login',
        component: Login,
        hidden: true
      },
      {
        path: '/dashboard',
        component: Dashboard,
        hidden: true
      }
    ]
  },
  {
    path: '/locations',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'LocationList',
        component: LocationList,
        hidden: true
      },
      {
        path: ':slug',
        name:"LocationSlug",
        component: LocationDetails,
        hidden: true
      }
    ]
  },
  {
    path: '/reservations',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':slug',
        name:'ReservationsSlug',
        component: Reservation,
        hidden: true
      },
      {
        path: 'confirmation/:id',
        component: ReservationConfirmation,
        hidden: true
      },
      {
        path: 'success/:id',
        component: ReservationSuccess,
        hidden: true
      }
    ]
  },
  {
    path: '/hotel-partners',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        component: HotelPartner,
        hidden: true
      }
    ]
  },
  {
    path: '/pages',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'apps',
        component: Apps,
        hidden: true
      },
      {
        path: 'privacy',
        component: Privacy,
        hidden: true
      },
      {
        path: 'terms',
        component: Terms,
        hidden: true
      },
      {
        path: 'contact',
        component: Contact,
        hidden: true
      },
      {
        path: 'cabanaapp-privacy',
        component: CabanaappPrivacy,
        hidden: true
      },
      {
        path: 'cabanaapp-terms',
        component: CabanaappTerms,
        hidden: true
      }
    ]
  },
  {
    path: '/login',
    component: Login,
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: AuthRedirect,
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: Redirect
      }
    ]
  },
  {
    path: '/404',
    component: Page404,
    hidden: true
  },
  {
    path: '/401',
    component: Page401,
    hidden: true
  }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js